// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-card[data-v-684f9fd2] {\n  margin-bottom: 10px;\n}\n.title[data-v-684f9fd2] {\n  font-size: 14px;\n  color: #909399;\n  line-height: 28px;\n}", ""]);
// Exports
module.exports = exports;
